"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { RatingStats } from "@/entities/IProfile";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import UserPageRepModifyModal from "@/components/user/rep/modify-rep/UserPageRepModifyModal";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { AnimatePresence } from "framer-motion";
export default function UserPageRepRepsTableItem(t0) {
  const $ = _c(28);
  const {
    rep,
    profile,
    canEditRep
  } = t0;
  const isPositiveRating = rep.rating > 0;
  const isPositiveRaterContribution = rep.rater_contribution > 0;
  const [isEditRepModalOpen, setIsEditRepModalOpen] = useState(false);
  let t1;
  if ($[0] !== canEditRep) {
    t1 = () => {
      if (canEditRep) {
        setIsEditRepModalOpen(true);
      }
    };
    $[0] = canEditRep;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onTableClick = t1;
  const t2 = rep.category;
  const t3 = canEditRep ? "hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer even:tw-bg-iron-900" : "even:tw-bg-iron-900";
  let t4;
  if ($[2] !== rep.category) {
    t4 = <td className="tw-max-w-[12rem] lg:tw-max-w-[20rem] tw-truncate tw-whitespace-nowrap tw-py-3 tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-base tw-font-medium tw-text-iron-50"><span>{rep.category}</span></td>;
    $[2] = rep.category;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `${isPositiveRating ? "tw-text-green" : "tw-text-red"} tw-whitespace-nowrap tw-py-3 tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-base tw-font-medium tw-text-right`;
  let t6;
  if ($[4] !== rep.rating) {
    t6 = formatNumberWithCommas(rep.rating);
    $[4] = rep.rating;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <td className={t5}>{t6}</td>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== rep.contributor_count) {
    t8 = formatNumberWithCommas(rep.contributor_count);
    $[9] = rep.contributor_count;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <td className="tw-whitespace-nowrap tw-py-3 tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-base tw-font-medium tw-text-right tw-text-iron-400">{t8}</td>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== canEditRep || $[14] !== isEditRepModalOpen || $[15] !== isPositiveRaterContribution || $[16] !== profile || $[17] !== rep.category || $[18] !== rep.rater_contribution) {
    t10 = canEditRep && <><td className={`${isPositiveRaterContribution ? "tw-text-green" : "tw-text-red"} tw-whitespace-nowrap tw-py-3 tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-base tw-font-medium tw-text-right`}>{rep.rater_contribution ? formatNumberWithCommas(rep.rater_contribution) : " "}</td><AnimatePresence mode="sync" initial={true}>{isEditRepModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageRepModifyModal profile={profile} category={rep.category} onClose={() => setIsEditRepModalOpen(false)} /></CommonAnimationOpacity>}</AnimatePresence></>;
    $[13] = canEditRep;
    $[14] = isEditRepModalOpen;
    $[15] = isPositiveRaterContribution;
    $[16] = profile;
    $[17] = rep.category;
    $[18] = rep.rater_contribution;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onTableClick || $[21] !== rep.category || $[22] !== t10 || $[23] !== t3 || $[24] !== t4 || $[25] !== t7 || $[26] !== t9) {
    t11 = <tr key={t2} className={t3} onClick={onTableClick}>{t4}{t7}{t9}{t10}</tr>;
    $[20] = onTableClick;
    $[21] = rep.category;
    $[22] = t10;
    $[23] = t3;
    $[24] = t4;
    $[25] = t7;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
function _temp(e) {
  return e.stopPropagation();
}